/* eslint-disable react/require-default-props */
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    flexGrow: 1,
  },
};

class SaveDialog extends React.Component {
  handleClose = () => {
    const { onClose: onCloseAlt } = this.props;

    onCloseAlt(true);
  };

  render() {
    const { ...other } = this.props;

    return (
      <Dialog
        onClose={this.handleClose}
        aria-labelledby="Save Configuration"
        {...other}
      >
        <DialogTitle id="form-dialog-title">Save Configuration</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Save configuration in My Configs
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="configsave-name"
            label="Name"
            InputProps={{ disableUnderline: true }}
            fullWidth
            variant="filled"
          />
          <TextField
            margin="dense"
            id="configsave-company"
            label="Customer (optional)"
            InputProps={{ disableUnderline: true }}
            fullWidth
            variant="filled"
          />
          <TextField
            margin="dense"
            id="configsave-desc"
            label="Description (optional)"
            InputProps={{ disableUnderline: true }}
            fullWidth
            variant="filled"
          />
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => this.handleClose(true)}>
            Save
          </Button>
          <Button onClick={() => this.handleClose('cancel')} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
SaveDialog.propTypes = {
  onClose: PropTypes.func,
};

export default withStyles(styles)(SaveDialog);
